import { __assign, __rest } from "tslib";
import React from 'react';
import './style.css';
import { FlexRow } from '../../layout/FlexRow';
import { Typography } from '../Typography';
import { colors } from '../../../theme';
export var RadioInput = function (_a) {
    var label = _a.label, name = _a.name, value = _a.value, checked = _a.checked, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = __rest(_a, ["label", "name", "value", "checked", "onChange", "disabled"]);
    return (React.createElement(FlexRow, { alignItems: 'center', columnGap: '15px' },
        React.createElement("input", __assign({ type: 'radio', value: value, name: name, checked: checked, onChange: onChange, disabled: disabled }, props)),
        typeof label === 'string' ?
            React.createElement(Typography, { variant: 'body-regular', style: { lineHeight: '0', color: disabled ? colors.gray[30] : '#232529' } }, label)
            :
                label));
};
